module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAGFBMVEVMaXH////////////////////////////eQubUAAAAB3RSTlMAELCAMKDQp5PdQQAAAEFJREFUCFtjYEAAFtNgBxDNqF5eXiQAZIiVA0EikKEOYhQBVZSDgQMDM4RhwMAKYQQgGHApuGK4doSBcCvglkIBACefIK0I4u/XAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ../assets/textures/point.png
// module id = 423
// module chunks = 0